<app-title-section></app-title-section>

<div class="card p-1" style="margin-left: 15px; margin-right: 15px">

    <div class="d-flex justify-content-between align-items-center">

        <div class="d-flex align-items-center">
            <ng-container>
                <img [src]="file" class="logo-img me-2">
                <p style="font-size: 22px;color: #2F2B3DE5">Vuexy</p>
            </ng-container>

        </div>

        <label > <strong class="size20">Inventaire/ </strong> <label class="text-muted size20"> INV-000001</label>  </label>


    </div>


    <div class="items mt-4">
        <div class="flex-grow-1">

        </div>
        <!-- Partie Détails du document -->
        <div class="flex-grow-1">
            <p style="color:#2F2B3DE5"><strong class="size15">Détails du document </strong></p>
            <hr class="section-line" style="color:#134AD3">


            <div class="items2">
                <div><label class=" spacelabel size15">Date</label></div>
                <div><label class="size15"> 19/08/2025 </label></div>

            </div>
            <hr>
            <div class="items2">
                <div class="spacelabel "><label class="size15">Entrepot</label></div>
                <div class="flex-grow-1"><label class="size15">Entrepot pricipal </label></div>

            </div>
            <hr>
            <div class="items2">
                <div><label class="size15 spacelabel">Projet</label></div>
                <div><label class="size15">--</label></div>

            </div>
            <hr>
            <div class="items2">
                <div><label class="size15 spacelabel">Note</label></div>
                <div><label class="size15">--</label></div>

            </div>

        </div>
    </div>


    <div class="products-section">
        <table class="products-table ">
            <thead style="height: 56px; background-color: #134AD329">
            <tr>
                <th>DÉSIGNATION</th>
                <th>QUANTITÉ</th>
                <th>QUANTITÉ DISPONIBLE</th>
                <th> VALEUR UNITAIRE</th>
                <th>TOTAL HT</th>
            </tr>
            </thead>
            <tbody>
            <tr>

            </tr>
            </tbody>
        </table>


    </div>

    <!-- Footer Info -->
    <div class="footer-info d-flex justify-content-between">
        <div class="company-info">
            <p class="size15"><strong>Entreprise </strong></p>
            <p class="information">Shopi</p>
            <p class="information">l'aouina cité wahat, tunis</p>
            <p class="information">null tunis</p>
            <p class="information">Matricule fiscal: 5885</p>
        </div>
        <div class="coordinates">
            <p class="size15"><strong> Coordonnées </strong></p>
            <p class="information">--</p>
            <p class="information">--</p>
        </div>
        <div class="bank-info">
            <p class="size15"><strong> Coordonnées bancaires </strong></p>
            <p class="information">STB-Société Tunisienne de Banque</p>
            <p class="information">TN5910006035183509478831</p>
        </div>
    </div>


</div>












